import { render, staticRenderFns } from "./MotorVehicle.vue?vue&type=template&id=2e765563&"
import script from "./MotorVehicle.vue?vue&type=script&lang=js&"
export * from "./MotorVehicle.vue?vue&type=script&lang=js&"
import style0 from "./MotorVehicle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorVehicle.vue"
export default component.exports